// Notification read status enum matching backend
export const NotificationReadStatus = {
    READ: 'READ',
    UNREAD: 'UNREAD',
    ALL: 'ALL'
};

// Actions for reducer
export const ACTIONS = {
    SET_LOADING: 'SET_LOADING',
    SET_NOTIFICATIONS: 'SET_NOTIFICATIONS',
    SET_ERROR: 'SET_ERROR',
    MARK_AS_READ: 'MARK_AS_READ',
    CLEAR_ERROR: 'CLEAR_ERROR'
};

// Reducer for the notifications context
export const notificationsReducer = (state, action) => {
    switch (action.type) {
        case ACTIONS.SET_LOADING:
            return {
                ...state,
                loading: action.payload
            };

        case ACTIONS.SET_NOTIFICATIONS:
            return {
                ...state,
                notifications: action.payload.content,
                pagination: {
                    page: action.payload.number,
                    size: action.payload.size,
                    totalElements: action.payload.totalElements,
                    totalPages: action.payload.totalPages
                },
                lastUpdated: new Date().toISOString()
            };

        case ACTIONS.MARK_AS_READ:
            return {
                ...state,
                notifications: state.notifications.map((notification) =>
                    notification.id === action.payload.id ? action.payload : notification
                ),
                lastUpdated: new Date().toISOString()
            };

        case ACTIONS.SET_ERROR:
            return {
                ...state,
                error: action.payload
            };

        case ACTIONS.CLEAR_ERROR:
            return {
                ...state,
                error: null
            };

        default:
            return state;
    }
};

// Initial state for the context
export const initialState = {
    notifications: [],
    loading: false,
    error: null,
    pagination: {
        page: 0,
        size: 20,
        totalElements: 0,
        totalPages: 0
    },
    lastUpdated: null
};
